import { forwardRef, inject, Injectable, Provider } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EViewType } from 'projects/shared/lib/enum/view-type/view-type.enum';
import { ENVIRONMENT } from 'projects/shared/lib/environment/environment';
import { ActivatedRoute } from '@angular/router';
import { IViewTypeService, IViewTypeServiceToken } from './view-type-service.interface';
import { IInitializable, INITIALIZABLE_SERVICES } from 'shared/app-core/initializable.interface';

@Injectable({
  providedIn: null,
  deps: [
    ActivatedRoute
  ]
})
export class ViewTypeService implements IViewTypeService, IInitializable {
  private readonly route: ActivatedRoute = inject(ActivatedRoute);

  private viewTypeSource: BehaviorSubject<EViewType>;
  private viewTypeObservable: Observable<EViewType>;
  private viewType: EViewType;

  public constructor() {
    this.viewType = ENVIRONMENT.productList.productListDefaultViewType;
    this.viewTypeSource = new BehaviorSubject<EViewType>(this.viewType);
    this.viewTypeObservable = this.viewTypeSource.asObservable();
  }

  public init(): void | Promise<void> {
    this.route.queryParamMap.subscribe(params => {
      let paramValue = params.get('viewType');
      if (paramValue != null) {
        this.viewType = parseInt(paramValue);
      }
    });
  }

  public viewTypeGet(): Observable<EViewType> {
    return this.viewTypeObservable;
  }

  public viewTypeSet(value: EViewType | undefined): void {
    if (value == undefined) {
      value = ENVIRONMENT.productList.productListDefaultViewType;
    }

    if (this.viewTypeSource.value == value) {
      return;
    }

    this.viewTypeSource.next(value);
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ViewTypeServiceProvider: Provider[] = [
  {
    provide: IViewTypeServiceToken,
    useClass: forwardRef(() => ViewTypeService),
    deps: [
      ActivatedRoute
    ]
  },
  {
    provide: INITIALIZABLE_SERVICES,
    useExisting: IViewTypeServiceToken,
    multi: true,
  }
];

